module.exports = __webpack_public_path__ + "static/media/ic-category-notice-on.d2e7b163.svg";